import { useEffect, useState } from 'react';

import { useAppStore } from '../store/appStore';
import { useLoadStore } from '../store/loadStore';

/** Matches the fade in the stylesheet. */
const FADE_MS = 600;

/**
 * What is on screen until the instrument is warm: the files coming down, the
 * scene being built, and the shaders being compiled, as one bar.
 *
 * It is opaque and takes the pointer, which is also what keeps a click from
 * reaching the instrument — that is live behind here through the warm-up, just
 * burnt down to nothing.
 */
export function Loader() {
  const phase = useAppStore((state) => state.phase);
  const progress = useLoadStore((state) => state.progress);
  const label = useLoadStore((state) => state.label);
  const [mounted, setMounted] = useState(true);

  // Held through the fade rather than cut on the last percent, so the title
  // card burns on behind the loader rather than after it.
  useEffect(() => {
    if (phase === 'loading') return;
    const timer = setTimeout(() => setMounted(false), FADE_MS);
    return () => clearTimeout(timer);
  }, [phase]);

  if (!mounted) return null;

  const leaving = phase === 'loading' ? '' : ' loader--leaving';

  return (
    <div className={`loader${leaving}`} role="status" aria-live="polite">
      <p className="loader__label">{label}</p>
      <div className="loader__track">
        <div className="loader__fill" style={{ transform: `scaleX(${progress})` }} />
      </div>
      <p className="loader__percent">{Math.round(progress * 100)}%</p>
    </div>
  );
}
